import { toUpper } from "lodash";

export const randomOrderNumberGenerator = (len) => {
    const length = (len) ? (len) : (10);
    const string = "abcdefghijklmnopqrstuvwxyz"; //to upper 
    const numeric = '0123456789';
    let orderNumber = "";
    let character = "";
    while (orderNumber.length < length) {
        const entity1 = Math.ceil(string.length * Math.random() * Math.random());
        const entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
        let hold = string.charAt(entity1);
        hold = (orderNumber.length % 2 === 0) ? (hold.toUpperCase()) : (hold);
        character += hold;
        character += numeric.charAt(entity2);
        orderNumber = character;
    }
    orderNumber = orderNumber.split('').sort(() => { return 0.5 - Math.random() }).join('');

    return orderNumber.slice(0, len);
};

export const randomSubscriptionNumberGenerator = (len) => {
    const length = (len) ? (len) : (10);
    const string = "abcdefghijklmnopqrstuvwxyz"; //to upper 
    const numeric = '0123456789';
    let subscriptionNumber = "";
    let character = "";
    while (subscriptionNumber.length < length) {
        const entity1 = Math.ceil(string.length * Math.random() * Math.random());
        const entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
        let hold = string.charAt(entity1);
        hold = (subscriptionNumber.length % 2 === 0) ? (hold.toUpperCase()) : (hold);
        character += hold;
        character += numeric.charAt(entity2);
        subscriptionNumber = character;
    }
    subscriptionNumber = subscriptionNumber.split('').sort(() => { return 0.5 - Math.random() }).join('');

    return subscriptionNumber.slice(0, len);
};

export const randomCodeGenerator = (len) => {
    const length = (len) ? (len) : (10);
    const string = "abcdefghijklmnopqrstuvwxyz"; //to upper 
    const numeric = '0123456789';
    let code = "";
    let character = "";
    while (code.length < length) {
        const entity1 = Math.ceil(string.length * Math.random() * Math.random());
        const entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
        let hold = string.charAt(entity1);
        hold = (code.length % 2 == 0) ? (hold.toUpperCase()) : (hold);
        character += hold;
        character += numeric.charAt(entity2);
        code = character;
    }
    code = code.split('').sort(() => { return 0.5 - Math.random() }).join('');

    return code.slice(0, len);
};

export const randomReferralCodeGenerator = (len = 5, firstName) => {
    const length = (len) ? (len) : (10);
    const numeric = '0123456789';
    let code = "";
    let character = "";
    while (code.length < length) {
        const entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
        character += numeric.charAt(entity2);
        code = character;
    }
    code = code.split('').sort(() => { return 0.5 - Math.random() }).join('');

    return 'READY' + toUpper(firstName) + code.slice(0, len);
};